// Donor-scope impact API helper — CHG-1517 wave 2.
//
// Backend: portal.py canonical GET /api/v1/my-giving/impact. Returns an
// untyped dict on the BE side; this helper types the response based on
// the actual fields the route emits (per portal.py:get_donor_impact).
//
// Shape:
//   {
//     total_given_minor_units: int,           // 0 if donor gave in 2+ currencies
//     total_given_per_currency: [...],  // CHG-0577 always populated
//     organizations: [
//       {
//         org_id: str,
//         org_name: str,
//         currency: str,                 // org's display currency
//         your_total_minor_units: int,
//         programs: [
//           {
//             designation_id: str,
//             designation_name: str,
//             designation_type: str,     // fund | program | project | cause | milestone
//             program_raised_minor_units: int, // org-wide raised total
//             program_goal_minor_units: int,   // org-wide goal (0 = no goal)
//             your_total_minor_units: int,
//             your_donation_count: int,
//           }
//         ]
//       }
//     ]
//   }

import { apiClient } from "./client";

export interface PortalImpactCurrencyTotal {
  currency: string;
  total_minor_units: number;
  count: number;
}

export interface PortalImpactProgram {
  designation_id: string;
  designation_name: string;
  designation_type: string;
  program_raised_minor_units: number;
  program_goal_minor_units: number;
  your_total_minor_units: number;
  your_donation_count: number;
}

export interface PortalImpactOrganization {
  org_id: string;
  org_name: string;
  currency: string;
  your_total_minor_units: number;
  programs: PortalImpactProgram[];
}

export interface PortalImpact {
  total_given_minor_units: number;
  total_given_per_currency: PortalImpactCurrencyTotal[];
  organizations: PortalImpactOrganization[];
}

export async function fetchMyImpact(): Promise<PortalImpact> {
  const r = await apiClient().get<PortalImpact>("/my-giving/impact");
  return r.data;
}

export const meImpactApi = {
  fetchMyImpact,
};
